import { BaseApiService } from '../../base-api-service';
import { TournamentUserStat } from '../../../models';
import { ApiVersions } from '../../../enums';
import { env } from '../../../environment';

class TournamentController extends BaseApiService {

  public async getTournamentUserStat(tournamentId: number): Promise<TournamentUserStat> {
    const url = `${this.url}/tournament/api/${ApiVersions.V1}/userTournament/userStat`;
    return await this.http.get(url, { params: { tournamentId } });
  }

}

export const tournamentController = new TournamentController({ url: env.origin });
